import _ from "lodash";
// Remove empty rows and rows with only prompts in MatchingPair object

// Get MatchingPairAnswers from MatchingPair object
export const getAnswers = pairs => {
  return _.filter(pairs, item => !_.isEmpty(_.get(item, "prompt.value"))).map(
    item => ({
      promptId: _.get(item, "prompt.id"),
      answerId: _.get(item, "answer.id"),
    })
  );
};

// Get index of the reused item
export const getReusedIndex = (matchingPairs, item) => {
  return (
    _.findIndex(
      matchingPairs,
      el =>
        el.prompt.id === _.get(item, "prompt.reusedFrom") &&
        !el.prompt.reusedFrom
    ) + 1
  );
};

// Update reuse options after delete
export const updateReusedAnswers = (prevmatchingPair, elementToDelete) => {
  return _.map(prevmatchingPair, element => {
    if (
      _.get(element, "prompt.reusedFrom") ===
      _.get(elementToDelete, "prompt.id")
    ) {
      return {
        ...element,
        prompt: {
          ...element.prompt,
          reusedFrom: "",
        },
      };
    }
    return element;
  });
};

// Update reuse options after reusedFrom is updated
export const updateReusedFrom = (
  updatedmatchingPair,
  oldPromptId,
  newPromptId
) => {
  const newItem = _.find(
    updatedmatchingPair,
    el => _.get(el, "prompt.id") === newPromptId
  );
  return _.map(updatedmatchingPair, element => {
    if (_.get(element, "prompt.reusedFrom") === oldPromptId) {
      return {
        ...element,
        prompt: {
          ..._.get(element, "prompt", {}),
          reusedFrom: newPromptId,
        },
        answer: _.get(newItem, "answer", {}),
      };
    }
    return element;
  });
};

// Filter responses
export const getFilteredResponses = (matchingPairsResponse, matchingPairs) => {
  return _.filter(matchingPairsResponse, responsePair => {
    const promptId = _.get(responsePair, "promptId", "");
    const index = _.findIndex(matchingPairs, matchingPair => {
      return _.get(matchingPair, "prompt.id", "") === promptId;
    });
    return index !== -1;
  });
};

// Get filtered options for dropdown
export const getFilteredOptions = (
  reuseOptions,
  currentAnswerId,
  matchingPairs
) => {
  return _.map(reuseOptions, group => {
    const options = _.get(group, "options", []);

    const filteredOptions = _.filter(options, option => {
      // check if same option as current prompt
      const answerId = _.get(option, "answerId");

      if (!answerId || answerId === currentAnswerId) {
        return false;
      }

      // check if it is reused prompt
      const promptId = _.get(option, "promptId");
      let matchingPair = _.find(
        matchingPairs,
        item => _.get(item, "prompt.id") === promptId
      );

      if (
        matchingPair &&
        !_.isEmpty(_.get(matchingPair, "prompt.reusedFrom", ""))
      ) {
        return false;
      }

      // check if answer value is empty
      matchingPair = _.find(
        matchingPairs,
        item => _.get(item, "answer.id") === answerId
      );
      return matchingPair && !_.isEmpty(_.get(matchingPair, "answer.value"));
    });

    return {
      ...group,
      options: filteredOptions,
    };
  });
};

// Get the answers selected by the student for dropdown
export const getSelectedValues = (
  matchingPairsResponse,
  answersOptions,
  item
) => {
  const promptId = _.get(item, "prompt.id");
  const answerObj = _.find(matchingPairsResponse, { promptId });
  const answerId = _.get(answerObj, "answerId");
  const answerOption = _.find(answersOptions, { key: answerId });
  return [_.get(answerOption, "label", "")];
};

// Get attempted answer value
export const getAttemptedAnswerValue = (
  answersOptions,
  matchingPairsResponse,
  item
) => {
  const promptId = _.get(item, "prompt.id");
  const index = _.findIndex(matchingPairsResponse, { promptId });
  const answerId = _.get(matchingPairsResponse, [index, "answerId"]);
  const answerObj = _.find(answersOptions, { key: answerId });
  const answerValue = _.get(answerObj, "label", "");
  return answerValue;
};

// Check if correct option is selected
export const isCorrect = (item, matchingPairsResponse) => {
  const promptId = _.get(item, "prompt.id");
  const attemptedValue = _.find(matchingPairsResponse, { promptId });
  const correctValue = {
    promptId,
    answerId: _.get(item, "answer.id"),
  };
  return _.isEqual(attemptedValue, correctValue);
};

// Check if attempted
export const isAttempted = (item, matchingPairsResponse) => {
  return (
    _.findIndex(matchingPairsResponse, {
      promptId: _.get(item, "prompt.id"),
    }) !== -1
  );
};

export const handleMediaUpload = ({
  file,
  getMediaImperativeHandler,
  currentUploadContext,
  setCurrentUploadContext,
}) => {
  if (!file || !currentUploadContext) return;

  const { accept, context, itemId } = currentUploadContext;

  if (accept === "image/*") {
    const objectUrl = URL.createObjectURL(file);
    const payload = {
      url: objectUrl,
      altText: "",
      fileObj: file,
      isUpload: true,
    };
    const currentImageHandler = getMediaImperativeHandler(
      "image",
      context,
      itemId
    );
    if (_.isFunction(_.get(currentImageHandler, "current.submit"))) {
      currentImageHandler.current.submit(payload);
    }
  } else {
    // Handle audio/video files
    const currentEmbedHandler = getMediaImperativeHandler(
      "embed",
      context,
      itemId
    );
    if (_.isFunction(_.get(currentEmbedHandler, "current.submit"))) {
      currentEmbedHandler.current.submit({
        type: "upload-file",
        file,
      });
    }
  }

  // Clear context after upload
  setCurrentUploadContext(null);
};
